import type { PropsWithChildren } from 'react';
import { ButtonGroup, Dropdown as ReactBootstrapDropdown } from 'react-bootstrap';
import { DropdownContext } from './DropdownContext';
import { DropdownItem } from './DropdownItem';
import { DropdownMenu } from './DropdownMenu';
import { DropdownToggle } from './DropdownToggle';

type DropDownMenuProps = {
  menuAlignment?: 'start' | 'center' | 'end';
  direction?: 'auto' | 'top' | 'bottom' | 'start' | 'end';
  // showMenu: boolean;
  size?: 'sm' | 'md' | 'lg' | 'xl';
  split?: boolean;
  color?: 'dark' | 'light' | 'primary' | 'secondary' | 'info' | 'success' | 'warning' | 'danger';
  purpose?: 'primary' | 'outline' | 'default' | 'discreet' | 'flat' | 'link';
};

type DropValue = 'up' | 'up-centered' | 'start' | 'end' | 'down' | 'down-centered' | undefined;

export const Dropdown = ({
  size = 'md',
  split = false,
  color = 'primary',
  purpose = 'primary',
  menuAlignment = 'end',
  direction = 'auto',
  children,
}: PropsWithChildren<DropDownMenuProps>) => (
  <ReactBootstrapDropdown
    className="dropdown-center"
    drop={getDropValue(direction, menuAlignment)}
    align={menuAlignment === 'center' ? undefined : menuAlignment}
    as={ButtonGroup}
  >
    <DropdownContext.Provider value={{ size, split, color, purpose }}>
      {children}
    </DropdownContext.Provider>
  </ReactBootstrapDropdown>
);

Dropdown.Toggle = DropdownToggle;
Dropdown.Menu = DropdownMenu;
Dropdown.Item = DropdownItem;
Dropdown.Separator = ReactBootstrapDropdown.Divider;

const getDropValue = (
  direction: 'auto' | 'top' | 'bottom' | 'start' | 'end',
  menuAlignment: 'start' | 'center' | 'end',
): DropValue => {
  if (menuAlignment === 'center') {
    return direction === 'top' ? 'up-centered' : 'down-centered';
  }

  if (direction === 'top') return 'up';
  if (direction === 'bottom') return 'down';
  if (direction === 'auto') return undefined;

  return direction;
};
